module.exports = __webpack_public_path__ + "static/media/tanmay_patil.251883d9.jpg";